import { useTranslation } from 'react-i18next'

import { RadioGroupOption } from 'components/Form'
import { AbTestVariant } from 'features/ab-tests/types/abTestVariant'
import { UseGetVariantOptions, UseGetVariantOptionsProps } from './types'

export const useGetVariantOptions = ({
  usedVariantsData,
}: UseGetVariantOptionsProps): UseGetVariantOptions => {
  const { t } = useTranslation('features/abTests', { keyPrefix: 'endTest.form.variant.options' })

  const emptyOption: RadioGroupOption = {
    label: t('emptyOption.label'),
    value: '',
  }

  const variantOptions: RadioGroupOption[] = usedVariantsData.map(
    (usedVariantData: AbTestVariant): RadioGroupOption => ({
      label: `${usedVariantData.name} (${usedVariantData.reportedKeyValue})`,
      value: usedVariantData.name,
    }),
  )

  return {
    variantOptions: [emptyOption, ...variantOptions],
  }
}
